module.exports = "<!-- Generated by IcoMoon.io -->\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n<title>keyboard_arrow_right</title>\n<path d=\"M8.578 16.359l4.594-4.594-4.594-4.594 1.406-1.406 6 6-6 6z\"></path>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg/keyboard_arrow_right.svg
// module id = 819
// module chunks = 0